import { makeStyles, Grid } from '@material-ui/core'

import { Container, Page, Header } from 'components'

import styles from './styles'
import { routes } from 'Routes'

const useStyles = makeStyles(styles)

const ChargesShow = () => {
  const classes = useStyles()

  return (
    <Page className={classes.root} title="Transações">
      <Container maxWidth="md">
        <Grid container spacing={8}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Header name="Cobranças" route={routes.charges.main} />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            Typography
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default ChargesShow
